import { howLongAgo } from '@fiverr-private/futile/lib/datetime';

export function dateStringToHowLongAgo(dateString) {
    return howLongAgo(new Date(dateString), {prefix:'reviews.general.how_long_ago.'});
}

export function round(num, precision = 0) {
    const power = Math.pow(10, precision);
    return Math.round(num * power) / power;
}


// WEBPACK FOOTER //
// ./src/reviews/utils.js